import React, { useEffect, useRef, useState } from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useField, useFormikContext } from 'formik';

const SelectWrapper = ({ name, options, initValues, ...otherProps }) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const selectRef = useRef(null);

  const handleChange = (evt) => {
    if (otherProps.onSelect) otherProps.onSelect(evt.target.value);
    const { value } = evt.target;
    setFieldValue(name, value);
    setOpen(false); // close dropdown after selection
  };

  // When the user presses Space or Enter, open the select options
  const handleKeyDown = (event) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      setOpen(!open);
    }
  };

  const configSelect = {
    ...field,
    ...otherProps,
    select: true,
    variant: 'outlined',
    fullWidth: true,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    borderRadius: '16px',
  };

  if (meta && meta.touched && meta.error) {
    configSelect.error = true;
    configSelect.helperText = meta.error;
  }

  useEffect(() => {
    try {
      if (initValues && initValues.length > 0) {
        initValues.forEach((item) => {
          if (item.name && item.value && item.setValueOnMount) {
            setFieldValue(item.name, item.value);
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [initValues, setFieldValue]);

  return (
    <TextField
      ref={selectRef}
      sx={{ width: '100%', borderRadius: '16px' }}
      {...configSelect}
      SelectProps={{
        open,
        onOpen: () => setOpen(true),
        onClose: () => setOpen(false),
       MenuProps: {
          ref: menuRef,
          PaperProps: {
            style: {
              maxHeight: '400px',
              width: selectRef.current ? selectRef.current.offsetWidth : 'auto',
            },
          },
        },
      }}
    >
      {Object.keys(options).map((item, pos) => (
        <MenuItem key={pos} value={options[item].key}
         sx={{
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {item}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectWrapper;
